<template>
  <section class="section-divider">
    <div class="container">
      <h2 data-aos="fade-up" data-aos-duration="600" class="section-title">
        {{ title }}
      </h2>
      <p
        data-aos="fade-up"
        data-aos-duration="600"
        data-aos-delay="400"
        class="section-description"
        v-if="description"
      >
        {{ description }}
      </p>
      <a
        data-aos="fade-up"
        data-aos-duration="600"
        data-aos-delay="600"
        :href="link"
        target="_blank"
      >
        <div class="button-wrap">
          {{ btntext }}
        </div>
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: "SectionDivider",
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    },
    link: {
      type: String
    },
    btntext: {
      type: String,
      default: "Get Started"
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variable.scss";
.section-divider {
  background: #293188;
  text-align: center;
  padding: 80px 0;
  .section-title {
    font-family: $heading-font;
    font-size: 36px;
    font-weight: 400 !important;
    color: #ffffff;
    text-transform: uppercase;
    margin: 0 !important;
  }
  .section-description {
    font-family: $content-font;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    max-width: 600px;
    margin: 30px auto 40px !important;
  }
  .button-wrap {
    font-family: $heading-font;
    font-size: 18px;
    color: $brand-color;
    text-transform: uppercase;
    font-weight: 400;
    letter-spacing: 1px;
    background: #ffffff;
    padding: 10px 80px;
    width: fit-content;
    margin: 0 auto;
    transition: all 0.2s ease-in-out;
    &:hover {
      background: $brand-color;
      color: #ffffff;
    }
  }
}
@media only screen and (max-width: 767px) {
  .section-divider {
    padding: 60px 0;
    .section-title {
      font-size: 32px;
    }
    .section-description {
      font-size: 15px;
    }
    .button-wrap {
      font-size: 16px;
    }
  }
}
@media only screen and (max-width: 425px) {
  .section-divider {
    padding: 50px 0;
    .section-title {
      font-size: 26px;
    }
    .section-description {
      font-size: 14px;
      margin: 15px auto 20px !important;
    }
    .button-wrap {
      font-size: 16px;
      padding: 8px 50px;
    }
  }
}
</style>
